import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgStarFilled = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12.0015 17.2699L16.6597 20.0814C17.2277 20.4243 17.9284 19.915 17.7777 19.2689L16.5415 13.9699L20.6579 10.4038C21.1594 9.96942 20.8913 9.14572 20.2302 9.08964L14.8115 8.62991L12.692 3.62919C12.4336 3.01941 11.5694 3.01941 11.3109 3.62918L9.19146 8.62991L3.77269 9.08964C3.11162 9.14572 2.84356 9.96942 3.34501 10.4038L7.46147 13.9699L6.22528 19.2689C6.07455 19.915 6.77523 20.4243 7.34321 20.0814L12.0015 17.2699Z"
          fill="currentColor"
        />
      </svg>
    </IconBase>
  );
};

SvgStarFilled.displayName = 'SvgStarFilled';
export default SvgStarFilled;
